import { NumberFormatStyle } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ToastController } from "@ionic/angular";

@Component({
  selector: "history-filter-component",
  templateUrl: "history-filter-component.html",
  styleUrls: ["./history-filter-component.scss"],
})
export class HistoryFilterComponent implements OnInit {
  @Input() profissionalInfo: any = {};
  @Input() infoUser: any = {};

  @Output() onFilterSelected = new EventEmitter();
  itemMenuSelected: any = "";
  itemSubMenuSelected: any = "";
  itemSubMenuSelected2: any = "";
  itemMiniMenuSelected: any = "";
  list: any[] = [
    {
      text: "Todos os documentos",
      icon: "/assets/icons/wallet.svg",
      query: "TODOS DOCUMENTOS",
      aberto: true,
      exec: true,
      subMenus: [
        {
          text: "Documentos Clinicos",
          icon: "/assets/icons/doc-clinicos.svg",
          query: "DOCUMENTOS CLINICOS",
          subMenus: [
            // {
            //   text: "Atestados",
            //   icon: "/assets/icons/med-plain.svg",
            //   query: "ATESTADOS",
            // },
            {
              text: "Atendimento e internações",
              icon: "/assets/icons/medical-bed.svg",
              query: "INTERNACOES",

              miniMenus: [
                {
                  text: "Atendimentos Clinicos",
                  icon: "/assets/icons/covid-research.svg",
                  query: "ATENDIMENTO CLÍNICO",
                },
                {
                  text: "Internações",
                  icon: "/assets/icons/covid-research.svg",
                  query: "INTERNAÇŌES",
                },
              ],
            },
            {
              text: "Exames",
              icon: "/assets/icons/microscope.svg",
              query: "EXAMES",
            },
            {
              text: "Medicamentos recebidos",
              icon: "/assets/icons/bottle.svg",
              query: "MEDICAMENTOS",
            },
            // {
            //   text: "Prescrições",
            //   icon: "/assets/icons/checklist.svg",
            //   query: "PRESCRICOES",
            // },
            // {
            //   text: "Solicitações reguladas",
            //   icon: "/assets/icons/agRegulados.svg",
            //   query: "SOLICITACOES REGULADAS",
            // },
            {
              text: "Vacinas",
              icon: "/assets/icons/injection.svg",
              query: "VACINAS",
            },
          ],
        },
        {
          text: "Registros autodeclarados",
          icon: "/assets/icons/cv.svg",
          query: "REGISTROS AUTODECLARADOS",
          breve: false,
          subMenus: [
            {
              text: "Alergias",
              icon: "/assets/icons/covid-research.svg",
              query: "ALERGIAS",
              breve: false,
            },
            {
              text: "Diário de saúde",
              icon: "/assets/icons/cardio.svg",
              query: "DIARIO",
              breve: false,
              miniMenus: [
                {
                  text: "Pressão",
                  icon: "/assets/icons/covid-research.svg",
                  query: "PRESSAO",
                },
                {
                  text: "Glicose",
                  icon: "/assets/icons/covid-research.svg",
                  query: "GLICOSE",
                },
                {
                  text: "IMC",
                  icon: "/assets/icons/covid-research.svg",
                  query: "IMC",
                },
              ],
            },
            {
              text: "Medicamentos Declarados",
              icon: "/assets/icons/pill.svg",
              query: "MEDICAMENTOS DECLARADOS",
              breve: false,
            },
          ],
        },
      ]
    },

    {
      text: "Contatos de emergência",
      icon: "/assets/icons/hospital-call.svg",
      query: "CONTATOS DE EMERGENCIA",
      breve: false,
    },
    {
      text: "Suporte",
      icon: "/assets/icons/medical-bed.svg",
      query: "SUPORTE",
      breve: false,
    },
  ];

  listaTipo = "welcome";

  constructor(private toastController: ToastController) { }

  ngOnInit() {
    console.log("ngOnInit -> SummaryComponent");
    console.log(this.infoUser);
  }

  async selectFilter(tipo: any, ev: Event, item) {
    if (tipo === "menu") {
      this.itemMenuSelected = item;
      if (item.exec) {
        this.itemSubMenuSelected = "";
        this.itemSubMenuSelected2 = "";
        this.itemMiniMenuSelected = "";
        ev.stopPropagation();
        this.onFilterSelected.emit({
          filtro: item.query.toUpperCase(),
        });
        return;
      }
      if (item.query === "REGISTROS AUTODECLARADOS") {
        this.itemSubMenuSelected = "";
        this.itemMiniMenuSelected = "";
        this.onFilterSelected.emit({
          filtro: this.itemMenuSelected.query.toUpperCase(),
        });
        return;
      }
      if (item.subMenus) {
        if (item.subMenus.includes(this.itemSubMenuSelected)) {
          this.onFilterSelected.emit({
            filtro: this.itemSubMenuSelected.query.toUpperCase(),
          });
          return;
        }
        item = item.subMenus[0];
        this.itemSubMenuSelected = item;
      }
      if (item.miniMenus) {
        if (item.miniMenus.includes(this.itemMiniMenuSelected)) {
          this.onFilterSelected.emit({
            filtro: this.itemMiniMenuSelected.query.toUpperCase(),
          });
          return;
        }
        item = item.miniMenus[0];
        this.itemMiniMenuSelected = item;
      }

    }

    if (tipo === "sub-menu") {
      ev.stopPropagation();
      this.itemSubMenuSelected = item;
      if (item.subMenus) {
        if (item.subMenus.includes(this.itemSubMenuSelected2)) {
          this.onFilterSelected.emit({
            filtro: this.itemSubMenuSelected2.query.toUpperCase(),
          });
          return;
        }
        item = item.subMenus[0];
        this.itemSubMenuSelected2 = item;
      }

      if (item.miniMenus) {
        if (item.miniMenus.includes(this.itemMiniMenuSelected)) {
          this.onFilterSelected.emit({
            filtro: this.itemMiniMenuSelected.query.toUpperCase(),
          });
          return;
        }
        item = item.miniMenus[0];
        this.itemMiniMenuSelected = item;
      }
    }

    if (tipo === "sub-menu-2") {
      ev.stopPropagation();
      this.itemSubMenuSelected2 = item;
      if (item.miniMenus) {
        if (item.miniMenus.includes(this.itemMiniMenuSelected)) {
          this.onFilterSelected.emit({
            filtro: this.itemMiniMenuSelected.query.toUpperCase(),
          });
          return;
        }
        item = item.miniMenus[0];
        this.itemMiniMenuSelected = item;
      }
    }

    if (tipo === "mini-menu") {
      ev.stopPropagation();
      this.itemMiniMenuSelected = item;
    }

    this.onFilterSelected.emit({
      filtro: item.query.toUpperCase(),
    });
  }
}
